import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import isUsingArtemisStyles from '../../../selectors/isUsingArtemisStyles';
import Typography from '../../../style-helper/Typography';
import loadArtemisFonts from '../loadArtemisFonts';

const useStyles = createUseStyles({
  mockInputWrapper: {
    flexGrow: 1,
  },
  
  mockInput: props => ({
    padding: [12, 8],
    lineHeight: '1',
    fontWeight: 400,
    border: [1, 'solid', '#8C8C8C'],
    borderRadius: 4,
    cursor: 'not-allowed',
    ...((props?.isUsingArtemisStyles && props?.theme?.typography?.[Typography.body])
      && (loadArtemisFonts(props?.theme?.typography[Typography.body], props?.theme?.button?.isBold))),
  }),
});

export function MockInput(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  useEffect(() => {
    props.validate({
      target: {
        value: props.inputValue,
      },
    });
  }, []);
  
  return (
    <div id={props.id} className={classes.mockInputWrapper} data-test="MockInput" data-cs-mask>
      <p
        data-test={`MockInput__${props.dataTestSuffix}`}
        className={`${classes.mockInput} ${props.errorText ? 'error-block-v2' : ''}`}
      >
        {props.displayValue}
      </p>
    </div>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

MockInput.propTypes = {
  id: PropTypes.string.isRequired,
  dataTestSuffix: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,
  errorText: PropTypes.string.isRequired,
  isUsingArtemisStyles: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(MockInput);
